import { PremiumStatusQueueItem } from './../model/PremiumStatusQueueItem';
export class PremiumStatusQueueItemBuilder {
    static buildPremiumStatusQueueItem(data) {
        let premiumStatusQueueItem = null;
        premiumStatusQueueItem = new PremiumStatusQueueItem();
        premiumStatusQueueItem.id_reservation = data.id_reservation;
        premiumStatusQueueItem.id_user = data.id_user;
        premiumStatusQueueItem.timestamp = data.timestamp;
        return premiumStatusQueueItem;
    }
}
//# sourceMappingURL=premium-status-queue-item-builder.js.map